// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.deployment.deployment_environment.DeploymentEnvironment

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { DeploymentServiceData, DeploymentServiceStore } from "./DeploymentService.generated";

export interface DeploymentEnvironmentData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "DeploymentEnvironment";
    id: string;
    name: string;
    engine_type: string;
    vault_id: string | null;
    engine_settings: Record<string, unknown>;
    services: DeploymentServiceData[];
    short_error: string | null;
    error: string | null;
}

export class DeploymentEnvironmentStore {
    readonly _entity_class_name = "DeploymentEnvironment" as const;
    id: string;
    name: string;
    engine_type: string;
    vault_id: string | null;
    engine_settings: Record<string, unknown>;
    services: DeploymentServiceStore[];
    short_error: string | null;
    error: string | null;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: DeploymentEnvironmentData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.id = wrapEntity(data.id, transport, [...chainPath, "id"]);
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]);
        this.engine_type = wrapEntity(data.engine_type, transport, [...chainPath, "engine_type"]);
        this.vault_id = wrapEntity(data.vault_id, transport, [...chainPath, "vault_id"]) ?? null;
        this.engine_settings = wrapEntity(data.engine_settings, transport, [...chainPath, "engine_settings"]);
        this.services = wrapEntity(data.services, transport, [...chainPath, "services"]);
        this.short_error = wrapEntity(data.short_error, transport, [...chainPath, "short_error"]) ?? null;
        this.error = wrapEntity(data.error, transport, [...chainPath, "error"]) ?? null;
        makeObservable(this, {
            id: observable,
            name: observable,
            engine_type: observable,
            vault_id: observable,
            engine_settings: observable,
            services: observable,
            short_error: observable,
            error: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async update_settings(name: any, engine_type: any, vault_id: any, engine_settings: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "update_settings", [name, engine_type, vault_id, engine_settings], {});
    }
}

registerEntity("DeploymentEnvironment", DeploymentEnvironmentStore);
